import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class PointsApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "points/";
	}

}
